module.exports = "/_next/static/images/9a3afd73ef19defbe76c03f014182fe6-device-frame-dark@0.75x.png";